<template>

   <div class="container">
       <div class="title text-left">{{ $t('impact.title') }}</div>
   </div>

 
<div   class="container text-justify pt-2 pb-2 ">


<div class="row mx-auto mt-5 mb-5">
    <div class="col mr-lg-5">
        <div class="mt-5 divoredTitle">{{ $t('impact.mission') }}</div>
        <h2 class="h2Title">
          {{ $t('impact.titleMission') }}
        </h2>
        <p class="mb-5">
          {{ $t('impact.contentMission') }}
        </p>
    </div>
    <div class="col-sm-12 col-md-6 order-first order-md-last">
      <img src="../../src/assets/img/impact/champsble.jpg" class="imgRounded img-fluid" alt="team-vm"/>
    </div>
</div>

<div class="highlighted text-center"> {{ $t('impact.objCarbon') }} </div>


<div class="row align-items-center">
  <div class="col mr-lg-5">
        <div class="mt-5 divoredTitle">Fleet</div>
        <h2 class="h2Title">
          {{ $t('impact.fleetTitle') }}
        </h2>
        <p class="mb-5">
          {{ $t('impact.fleetContent') }}
        </p>
    </div>
  <div class="col-sm-12 col-md-6 order-first order-md-last">
      <img src="../../src/assets/img/impact/transport.jpg" class="imgRounded img-fluid" alt="team-vm"/>
    </div>
</div>
<div class="row align-items-center pb-5 mb-5">
  <div class="col mr-lg-5">
        <div class="mt-5 divoredTitle">{{ $t('echangesagris') }}</div>
        <h2 class="h2Title">
          {{ $t('impact.echagTitle') }}
        </h2>
        <p class="mb-5">
          {{ $t('impact.echagContent') }}
        </p>
    </div>
  <div class="col-sm-12 col-md-6 order-first order-md-last">
      <img src="../../src/assets/img/impact/economiecirculaire.jpg" class="imgRounded img-fluid" alt="team-vm"/>
    </div>
</div>

<div class="text-center pt-5 mt-5">
  <div class="mt-5 divoredTitle">Dans notre quotidien</div>
  <h2 class="mb-5 styles.h2Title">
      les gouttes d'eau qui font des fleuves
  </h2>
</div>
 
 <div class="row mt-5 mx-auto">
     <div class="col-lg-4 col-md-6 mb-4">
         <div class="impactBlock a">
              <img src="../../src/assets/img/impact/delivery.svg" class="imgRounded" height="100" width="100" alt="team-vm"/>
              <div class="title">
              Transports
              </div>
              <div class="content">
                En plus d'être localisé au coeur d'un quartier résidentiel, déservie par tous les transports en commun de Reims et proche d'une station de vélos électriques, nous participons aux échanges menés par le service mobilité du Grand Reims pour réflechir et trouver les solutions les plus vertueuses pour le déplacement de nos équipes.
              </div>
         </div>
     </div>
     <div class="col-lg-4 col-md-6 mb-4">
          <div class="impactBlock b" >
            <img src="../../src/assets/img/impact/server.svg" class="imgRounded" height="100" width="100" alt="team-vm"/>
              <div class="title">
              Serveurs
              </div>
              <div class="content">
              L'ensemble de nos services est hébergé en France sur des serveurs AWS (Amazon Web Services) et nous restons constamment attentifs à son impact carbone via leur <a href="https://aws.amazon.com/fr/about-aws/whats-new/2022/03/aws-launches-customer-carbon-footprint-tool/">outil de mesure de l'empreinte carbone</a> lancé le 1er Mars 2022.
              </div>
          </div>
     </div>
     <div class="col-lg-4 col-md-6 mb-4">
          <div class="impactBlock c">
            <img src="../../src/assets/img/impact/building.svg" class="imgRounded" height="100" width="100" alt="team-vm"/>
              <div class="title">
              Batiment
              </div>
              <div class="content">
              Dans un souci de valorisation de l’immeuble dans lequel nous sommes domiciliés, notre bailleur s’est soumis aux exigences de la <a href="https://www.breeam.com/">certification BREEAM</a>.
              </div>
          </div>
     </div>
     <div class="col-lg-4 col-md-6 mb-4">
          <div class="impactBlock b">
            <img src="../../src/assets/img/impact/computer.svg" class="imgRounded" height="100" width="100" alt="team-vm"/>
              <div class="title">
              Matériel informatique
              </div>
              <div class="content">
              Nous louons notre matériel informatique à une société garantissant le recyclage des machines à l'issue du contrat de location, ainsi nous participons à la réduction des déchets numériques !
              </div>
         </div>
     </div>
     <div class="col-lg-4 col-md-6 mb-4">
          <div class="impactBlock c">
            <img src="../../src/assets/img/impact/coffee.svg" class="imgRounded" height="100" width="100" alt="team-vm"/>
              <div class="title">
              Café
              </div>
              <div class="content">
              Nous n'utilisons aucune capsule ou gobelet jetable ! Nous nous fournissons en café grain chez un toréfacteur local et utilisons nos belles tasses AgriVitech.
              </div>
         </div>
     </div>
     <div class="col-lg-4 col-md-6 mb-4">
          <div class="impactBlock a">
            <img src="../../src/assets/img/impact/meal.svg" class="imgRounded" height="100" width="100" alt="team-vm"/>
              <div class="title">
              Repas
              </div>
              <div class="content">
              Nous favorisons l'accès aux produits locaux en utilisant les offres de marchés des producteurs, Sacrés Fermiers, etc...
              </div>
         </div>
     </div>
 </div>   
</div>

</template>

<script >
export default {
    name: 'Agrivitechpourleclimat',
    components:{},
    props:{},
    metaInfo() {
        return { 
            title: "AgriVitech, notre mission : participer à la réduction de l'impact écologique de notre agriculture !",
            meta: [
                { name: 'robots', content: 'index,follow'},
                { name: 'title', content: "AgriVitech, notre mission : participer à la réduction de l'impact écologique de notre agriculture !"},
                { name: 'description', content: "Nous travaillons avec les plus grands acteurs agro-industrielles et contribuons à réduire l'impact écologique de leurs activités de transport, avec des pratiques collaboratives d'économie circulaire, et en leur donnant accès à des outils digitaux SaaS neutres en carbone !"},
                { property: 'og:title', content: "AgriVitech, notre mission : participer à la réduction de l'impact écologique de notre agriculture !"},
                { property: 'og:description', content: "Nous travaillons avec les plus grands acteurs agro-industrielles et contribuons à réduire l'impact écologique de leurs activités de transport, avec des pratiques collaboratives d'économie circulaire, et en leur donnant accès à des outils digitaux SaaS neutres en carbone !"},
                { property: 'og:site_name', content: 'AgriVitech'},
                { property: 'og:type', content: 'website'},    
                { property: 'og:url', content: 'https://www.agrivitech.com.com'},
                { property: 'og:image', content: 'https://www.agrivitech.com/seo-impact.png' },
                { property:"twitter:card", content:"summary_large_image"},
                { property:"twitter:url" , content: 'https://www.agrivitech.com.com'},
                { property:"twitter:title" , content:"AgriVitech, notre mission : participer à la réduction de l'impact écologique de notre agriculture !" },
                { property:"twitter:description" , content:"Nous travaillons avec les plus grands acteurs agro-industrielles et contribuons à réduire l'impact écologique de leurs activités de transport, avec des pratiques collaboratives d'économie circulaire, et en leur donnant accès à des outils digitaux SaaS neutres en carbone !" },
                { property:"twitter:image" , content:'https://www.agrivitech.com/seo-impact.png' }
            ]
        }
    }
    
}
</script>

<style lang="scss" scoped>

 .container-fluid{
     padding-left: 5vh;
     padding-right: 5vh;
     .card{
        border-radius: 20px;
        padding: 20px;
        .highlighted{
            padding: 0px;
            margin: 0px;
        }
     }
 }

 
.imgRounded {
  border-radius: 15px;
}

.headerImpact {
  height: 400px;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
//   color: $primary-color;

  h2 {
    position: relative;
    font-size: 50px;
    // color: $primary-color;
    font-weight: 700;
  }

  .titleBackground {
    position: relative;
    font-size: 40px;
    line-height: 0.9;
    text-align: center;
    font-weight: 600;
  }

  .numberBackground {
    position: relative;
    font-size: 50px;
    text-align: center;
    font-weight: 700;
  }

  .textBackground {
    position: relative;
    font-size: 30px;
    text-align: center;
    font-weight: 700;
  }
}

.h2Title {
  position: relative;
  font-size: 35px;
//   color: $primary-color;
  font-weight: 800;
}

.textImpact {
  line-height: 1.6;
  font-size: 18px;
  font-weight: 400;
//   color: $primary-color;
  li {
    padding-bottom: 20px;
  }
  .titleLine {
    text-align: center;
    // color: $green-btn;
    font-size: 20px;
    font-weight: 600;
  }
}

.coloredTitle {
//   color: $secondary-color;
  font-weight: 500;
  text-transform: uppercase;
}
.impactBlock {
  padding: 30px;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 25px;
//   color: $primary-color;
  margin-bottom: 15px;
  background-color: "#e8e6f6";
  height: 100%;
  .title {
    font-size: 17px!important;
    font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 15px;
    margin-top: 15px;
  }
  .content {
    font-size: 14px;
  }
  &.a{
    background-color: #adffe2;
  }
  &.b{
    background-color: #e4fff5;
  }
  &.c{
    background-color: #d7fff0;
  }
}

</style>